import queryString from 'query-string';
import { PageableQueryParams } from 'src/entities/basic-types/Pageable';
import callApi, { CallApiResult } from '.';

export const getPaypalBatches = (pageable: PageableQueryParams): Promise<CallApiResult> => {
    const query = queryString.stringify(pageable);
    return callApi(`/api/batch/paypal/list?${query}`);
};

export const getPaypalBatchFileDetails = (paypalBatchFileId: string): Promise<CallApiResult> => {
    return callApi(`/api/batch/paypal/fileDetails?batchFileId=${paypalBatchFileId}`);
};

export const getPaypalUnassignedOrders = (paypalBatchFileDetailId: string): Promise<CallApiResult> => {
    return callApi(`/api/batch/paypal/unassignedOrders?batchFieldDetailId=${paypalBatchFileDetailId}`);
};

export const uploadPaypalBatchFile = (uploadFile: FormData): Promise<CallApiResult> => {
    return callApi('/api/batch/paypal/upload', {
        method: 'POST',
        data: uploadFile,
    });
};

export const assignPaypalBatchFileToOrder = (
    paypalBatchFileId: string,
    orderId?: number | undefined
): Promise<CallApiResult> => {
    let query = `?fileDetailId=${paypalBatchFileId}`;

    if (orderId) {
        query += `&orderId=${orderId}`;
    }
    return callApi(`/api/batch/paypal/fileDetail/assignToOrder${query}`, { method: 'PUT' });
};

export const downloadPaypalBatchRZLExport = (batchId: string): Promise<CallApiResult> => {
    const endpoint = '/api/batch/paypal/rzlExport';
    return callApi(endpoint, { responseType: 'blob', params: { batchId } });
};
